import { useEffect, useState } from 'react'
import { Container, Grid, Box, Paper } from '@mui/material'

import BankingChart from '../../common/BankingChart/BankingChart'

import { getBankingHistoryIntranet } from './api/apiBankingHistoryIntranet'
import LoadingScreen from '../../common/LoadingScreen/components/LoadingScreen'

const centerStyle = {
  minHeight: '200px',
  background: 'white',
  fontSize: '24px',
  justifyContent: 'center',
  verticalAlign: 'middle',
  display: 'flex',
  alignItems: 'center',
}

export const BankingHistoryIntranet = ({ coproId }) => {
  const [bankingHistoryData, setBankingHistoryData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const fetchBankingHistory = async (id) => {
    setIsLoading(true)

    const res = await getBankingHistoryIntranet(id)
    setBankingHistoryData(res)

    setIsLoading(false)
  }

  useEffect(() => {
    fetchBankingHistory(coproId)
  }, [])

  return (
    <Box component={Paper} padding={'25px'}>
      <Container disableGutters sx={{ maxWidth: '100%' }}>
        <Grid item xs={12}>
          {isLoading ? (
            <LoadingScreen />
          ) : (
            <>
              {bankingHistoryData && bankingHistoryData.length > 0 ? (
                <BankingChart bankingHistoryData={bankingHistoryData[0]} />
              ) : (
                <div style={centerStyle}>
                  Historique bancaire non disponible pour cette copropriété ...
                </div>
              )}
            </>
          )}
        </Grid>
      </Container>
    </Box>
  )
}
